import axios from 'axios';
import config from '../config.json';

import {
  GET_USERS_SUCCESS,
  GET_CUSTOMERS_SUCCESS,
  GET_SITES_SUCCESS,
  GET_DEVICES_SUCCESS,
  GET_CAMERAS_SUCCESS,
  GET_VIEWS_SUCCESS,
  UPDATE_USERS,
  UPDATE_CUSTOMERS,
  UPDATE_SITES,
  UPDATE_DEVICES,
  UPDATE_CAMERAS,
  UPDATE_VIEWS,
} from './types';

const API_URL = process.env.REACT_APP_BACKEND || config.backend;

export const getCustomers = (deviceIdList, token, user) => {
  return async ( dispatch ) => {
    await  axios({
      method: 'get',
      url: API_URL + `ve/customers?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response || !response.data){
        throw new Error('bad response from get customer list.')
      };

      dispatch({
        type: GET_CUSTOMERS_SUCCESS,
        payload: response.data
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const getSites = (deviceIdList, token, user) => {
  return async ( dispatch ) => {
    await  axios({
      method: 'get',
      url: API_URL + `ve/projects?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response || !response.data){
        throw new Error('bad response from get site list.')
      };

      dispatch({
        type: GET_SITES_SUCCESS,
        payload: response.data
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const getDevices = (deviceIdList, token, user) => {
  return async ( dispatch ) => {
    await  axios({
      method: 'get',
      url: API_URL + `ve/devices?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response || !response.data){
        throw new Error('bad response from get device list.')
      };

      dispatch({
        type: GET_DEVICES_SUCCESS,
        payload: response.data
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const getCameras = (deviceIdList, token, user) => {
  return async ( dispatch ) => {

    await  axios({
      method: 'get',
      url: API_URL + `ve/cameras?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response || !response.data){
        throw new Error('bad response from get camera list.')
      };

      dispatch({
        type: GET_CAMERAS_SUCCESS,
        payload: response.data
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const getViews = (deviceIdList, token, user) => {
  return async ( dispatch ) => {

    await  axios({
      method: 'get',
      url: API_URL + `ve/views?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response || !response.data){
        throw new Error('bad response from get view list.')
      };

      dispatch({
        type: GET_VIEWS_SUCCESS,
        payload: response.data
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const getUsers = (deviceIdList, token, user) => {
  return async ( dispatch ) => {
    await  axios({
      method: 'get',
      url: API_URL + `ve/users?device=${deviceIdList[0]}&id=${user.bID}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
    .then((response) => {
      if(!response.data){
        throw new Error('bad response from get user list.')
      };

      dispatch({
        type: GET_USERS_SUCCESS,
        payload: response.data,
      })
    })
    .catch( error => {
        console.log(error);
    });
  };
}

export const updateCustomers = (payload) => {
  return {
    type: UPDATE_CUSTOMERS,
    payload: payload
  }
}

export const updateSites = (payload) => {
  return {
    type: UPDATE_SITES,
    payload: payload
  }
}

export const updateDevices = (payload) => {
  return {
    type: UPDATE_DEVICES,
    payload: payload
  }
}

export const updateCameras = (payload) => {
  return {
    type: UPDATE_CAMERAS,
    payload: payload
  }
}

export const updateViews = (payload) => {
  return {
    type: UPDATE_VIEWS,
    payload: payload
  }
}

export const updateUsers = (payload) => {
  return {
    type: UPDATE_USERS,
    payload: payload
  }
}